import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, TableWrapper, commonFilterMeta } from '../../../Common/Table/types';
import Table from '../../../Common/Table/Table';
import PaginationMobile from '../../../../../../pages/Responsive/PaginationMobile';
import useGetNewProjectData from '../../../../hooks/useGetNewProjectData';
import { RootState } from '../../../../../../redux/root';
import { headers } from '../../Inspections/InspectionsTable';
import useOnCommonTableActivity from '../../../../hooks/useOnCommonTableActivity';
import useStatusFilter from '../../../../hooks/useStatusFilter';
import { ProjectPermitInvoiceType } from '../../../../../../Components/InvoiceTool/types';
import { setSelectedProjectInvoice } from '../../../../../../redux/slices/feesSlice';

const InvoicesTable = () => {
    useGetNewProjectData({ invoices: true });
  const dispatch = useDispatch();
  const invoicesProjectList = useSelector((s: RootState) => s.fees.clientProjecPermitList);
  const invoicesLoading = useSelector((s: RootState) => s.fees.invoicesLoading);
  const { filteredRows, withStatusFilter } = useStatusFilter(invoicesProjectList);
  const { visibleItems } = useOnCommonTableActivity(filteredRows);
  const [withInvoice, setWithInvoice] = useState([]);

  useEffect(() => {
    if (visibleItems.length > 0) {
      const prjWithFees = visibleItems.reduce((prjArr, prj) => {
        if (prj.permit.invoices.length > 0) {
          prjArr.push(prj);
        }
        return prjArr;
      }, []);
      setWithInvoice(prjWithFees);
    } else {
      setWithInvoice([]);
    }
  }, [visibleItems]);
  const onPermitFeeSelected = (item: ProjectPermitInvoiceType) => {
    dispatch(setSelectedProjectInvoice(item));
  };
  return (
    <TableWrapper>
      <Table
        collection={withInvoice}
        headers={withStatusFilter(headers)}
        filterMeta={commonFilterMeta}
        gridTemplateCols="1fr 1fr 168px 110px 90px"
        setSelectedItemInSlice={onPermitFeeSelected}
        isLoading={invoicesLoading && withInvoice.length === 0}
      />
      <Pagination>
        <PaginationMobile showEverywhere />
      </Pagination>
    </TableWrapper>
  );
};

export default InvoicesTable;
